import type { ComponentPropsWithoutRef, ElementType } from "react";
import clsx from "clsx";

type PageSectionCardProps<T extends ElementType> = {
  as?: T;
} & Omit<ComponentPropsWithoutRef<T>, "as">;

const PageSectionCard = <T extends ElementType = "section",>({
  as,
  className,
  children,
  ...props
}: PageSectionCardProps<T>) => {
  const Component = as ?? "section";

  return (
    <Component
      className={clsx(
        "rounded-[1.5rem] border border-myteengig-border bg-white p-4 shadow-sm sm:rounded-[1.75rem] sm:p-6",
        className,
      )}
      {...props}
    >
      {children}
    </Component>
  );
};

export default PageSectionCard;
